import { render, staticRenderFns } from "./CollectionsBar.vue?vue&type=template&id=0c32438d&scoped=true&"
import script from "./CollectionsBar.vue?vue&type=script&lang=js&"
export * from "./CollectionsBar.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsBar.vue?vue&type=style&index=0&id=0c32438d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32438d",
  null
  
)

export default component.exports